import PropTypes from 'prop-types';

export default function Toggle({ value, onChange, options, className }) {
  return (
    <div className={`c-toggle ${className || ''}`}>
      {options.map(({ label, value: inputValue, Icon }) => (
        <div key={label} className="c-toggle__group">
          <input
            className="c-toggle__input u-visually-hidden"
            type="radio" // Made this a radio button so this toggle can be used with more than 2 options
            id={label}
            value={inputValue}
            checked={value === inputValue}
            onChange={onChange}
            name="toggle"
          />
          <label className="c-toggle__label" htmlFor={label}>
            {Icon && <Icon className="c-toggle__icon" />}
            {label}
          </label>
        </div>
      ))}
    </div>
  );
}

Toggle.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
};
